document.addEventListener("DOMContentLoaded", function() {
  
  // Selecciona todos los divs que tengan CUALQUIERA de los dos atributos
  const etiquetas = document.querySelectorAll(
    'div[data-label-type="sale"], div[data-label-type="mas-vendido"]'
  );
  
  // Revisa cada elemento encontrado
  etiquetas.forEach(function(etiqueta) {
    
    // Limpia espacios y obtiene el texto
    const textoInterno = etiqueta.textContent.trim();
    
    // Si el texto es exactamente "Oferta", aplica la clase
    if (textoInterno === 'Oferta') { 
      etiqueta.classList.add('etiqueta-oferta-visible');
    }
  });

});